// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SetPasswordModal-module__content___E_vI5 {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.SetPasswordModal-module__message___ifm8Y {
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
}

.SetPasswordModal-module__description___vlo0n {
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 1rem;
}

.SetPasswordModal-module__buttonGroup___KbHKl {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
}

.SetPasswordModal-module__button___kKfrJ {
  width: 100%;
}

.SetPasswordModal-module__input___b7pje {
  margin-bottom: 1rem;
}

.SetPasswordModal-module__buttonsContainer___xb68b {
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #e0e0e0;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.SetPasswordModal-module__buttonsContainer___xb68b button {
  flex: 0 0 auto;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/popups/SetPasswordModal/SetPasswordModal.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;EACA,6BAAA;EACA,eAAA;EACA,2BAAA;AACF;AACE;EACE,cAAA;EACA,mBAAA;AACJ","sourcesContent":[".content {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.message {\n  font-size: 1rem;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.description {\n  font-size: 1rem;\n  line-height: 1.5;\n  margin-bottom: 1rem;\n}\n\n.buttonGroup {\n  display: flex;\n  flex-direction: row;\n  gap: 0.75rem;\n}\n\n.button {\n  width: 100%;\n}\n\n.input {\n  margin-bottom: 1rem;\n}\n\n.buttonsContainer {\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid #e0e0e0;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  \n  button {\n    flex: 0 0 auto;\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `SetPasswordModal-module__content___E_vI5`,
	"message": `SetPasswordModal-module__message___ifm8Y`,
	"description": `SetPasswordModal-module__description___vlo0n`,
	"buttonGroup": `SetPasswordModal-module__buttonGroup___KbHKl`,
	"button": `SetPasswordModal-module__button___kKfrJ`,
	"input": `SetPasswordModal-module__input___b7pje`,
	"buttonsContainer": `SetPasswordModal-module__buttonsContainer___xb68b`
};
module.exports = ___CSS_LOADER_EXPORT___;
